export default __webpack_public_path__ + "static/media/trylleby-property-03.c6a12949.jpg";